var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRightArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 16,
    viewBox: "0 0 10 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.3824 0.352185C0.137549 0.577756 0 0.883657 0 1.20262C0 1.52157 0.137549 1.82747 0.3824 2.05305L6.84743 8.00726L0.3824 13.9615C0.144488 14.1883 0.0128441 14.4922 0.0158205 14.8076C0.018796 15.123 0.156154 15.4247 0.398309 15.6477C0.640465 15.8707 0.968042 15.9972 1.31049 16C1.65294 16.0027 1.98285 15.8815 2.22918 15.6623L9.6176 8.85769C9.86245 8.63212 10 8.32622 10 8.00726C10 7.6883 9.86245 7.3824 9.6176 7.15683L2.22918 0.352185C1.98425 0.126681 1.65211 0 1.30579 0C0.959466 0 0.627323 0.126681 0.3824 0.352185Z",
    fill: "#50ABFF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow);
export default __webpack_public_path__ + "static/media/rightArrow.ae1c40ae2b9dbc9e9a6093bb2d454d4b.svg";
export { ForwardRef as ReactComponent };